import { getApi } from '../api';
import { useQuery } from '@tanstack/react-query';

export const useGetLoggedUser = () => {
  const queryFn = async () => {
    const result = await getApi().get(`/users/logged_user`);
    const { as3_access: secretAccessKey, as3_bucket: bucketName, as3_key_id: accessKeyId } = result.headers;

    const amazonS3Config = {
      secretAccessKey,
      bucketName,
      accessKeyId,
      s3Url: `${process.env.REACT_APP_AS3_URL}${bucketName}`,
      region: process.env.REACT_APP_AS3_REGION
    };

    return { currentUser: result.data, amazonS3Config };
  };

  return useQuery({
    queryFn,
    queryKey: ['GET_logged_user'],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};

export const useGetUsers = ({ clientId }, config) => {
  const queryFn = async context => {
    const [clientId] = context.queryKey;
    const result = await getApi().get(`clients/${clientId}/users`);

    return result.data;
  };

  return useQuery({
    queryFn,
    queryKey: [clientId, 'GET_users'],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...config
  });
};
